module.exports = __webpack_public_path__ + "static/media/10.fd56d420.png";